import { stagePermissions } from "./PermissionsData"

const SessionData = {

    user: { type: "user", key: 'user', information: { label: '{{lang}}User' } },
    country: { type: "country", key: 'country', information: { label: '{{lang}}Country' } },
    language: { type: "language", key: 'language', information: { label: '{{lang}}Language' } },
    ip: { type: "ip", key: 'ip', information: { label: '{{lang}}IP' } },

}

const EntitiesData = {

    user: {

        relation: { type: "relation", key: 'relation', information: { label: '{{lang}}Relation info' } },
        name: { type: "string", key: 'name', information: { label: '{{lang}}Name' } },
        family: { type: "string", key: 'family', information: { label: '{{lang}}Family' } },
        fullname: { type: "string", key: 'fullname', information: { label: '{{lang}}Fullname' } },
        username: { type: "string", key: 'username', information: { label: '{{lang}}Username' } },
        image: { type: "image", key: 'image', information: { label: '{{lang}}Image' } },

    },


    frame: {

        name: { type: "string", key: 'name', information: { label: '{{lang}}Name' } },
        slug: { type: "string", key: 'slug', information: { label: '{{lang}}Slug' } },
        hub: { type: 'user', key: 'hub', information: { label: '{{lang}}Hub' } },
        creator: { type: 'user', key: 'creator', information: { label: '{{lang}}Creator' } },
        applet: { type: 'applet', key: 'applet', information: { label: '{{lang}}Applet' } },
    },

    stage: {

        // id: { type: "string" ,key: 'name'},
        name: { type: "string", key: 'name', information: { label: '{{lang}}Name' } },
        // premissions: { type: 'permission', key: 'premissions', information: { label: '{{lang}}Premissions' }, permissions: stagePermissions.permissions },

    },

    applet: {
        name: { type: "string", key: 'name', information: { label: '{{lang}}Name' } },
        slug: { type: "string", key: 'slug', information: { label: '{{lang}}Slug' } },
        creator: { type: 'user', key: 'creator', information: { label: '{{lang}}Creator' } },

    },


    price: {
        base: { type: "number", key: 'base', information: { label: '{{lang}}Base' } },
        discount: { type: "number", key: 'discount', information: { label: '{{lang}}Discount' } },
        final: { type: 'number', key: 'final', information: { label: '{{lang}}Final' } },

    },

}



export { EntitiesData, SessionData }